module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "administratormanagement"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("管理员管理")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700"
    }
  }, [_vm._v("搜索管理员")]), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "dashed": ""
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.searchlist.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "phone_number", $$v)
      },
      expression: "searchlist.phone_number"
    }
  })], 1), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "96px",
      "font-size": "12px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.searchbtn
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.adminlist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.adminlist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("用户名")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("显示名")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("手机验证")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("是否激活")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("权限组")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("操作")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.adminlist), function(admin) {
    return _c('div', {
      key: admin,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border-bottom": "#e8e8e8 dashed 1px",
        "min-height": "60px",
        "padding": "5px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      },
      on: {
        "click": function($event) {
          return _vm.gotoadmininfo(admin)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(admin.id))])]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      },
      attrs: {
        "span": 2
      }
    }, [_c('a-popover', {
      attrs: {
        "placement": "topLeft",
        "trigger": "hover"
      }
    }, [_c('template', {
      slot: "content"
    }, [_c('p', [_vm._v(_vm._s(admin.username))])]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(admin.username) + "\n\t\t\t\t\t\t\t\t\t\t")], 2)], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      },
      attrs: {
        "span": 3
      }
    }, [_c('a-popover', {
      attrs: {
        "placement": "topLeft",
        "trigger": "hover"
      }
    }, [_c('template', {
      slot: "content"
    }, [_c('p', [_vm._v(_vm._s(admin.display_name))])]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(admin.display_name) + "\n\t\t\t\t\t\t\t\t\t\t")], 2)], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(admin.phone_number))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [(admin.phone_verified) ? _c('a-icon', {
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "type": "check-circle"
      }
    }) : _c('a-icon', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "type": "close-circle"
      }
    })], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      },
      attrs: {
        "span": 2
      }
    }, [_c('a-popover', {
      attrs: {
        "placement": "topLeft",
        "trigger": "hover"
      }
    }, [_c('template', {
      slot: "content"
    }, [_c('p', [_vm._v(_vm._s(admin.email))])]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(admin.email) + "\n\t\t\t\t\t\t\t\t\t\t")], 2)], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [(admin.is_active) ? _c('a-icon', {
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "type": "check-circle"
      }
    }) : _c('a-icon', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "type": "close-circle"
      }
    })], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(_vm.permission_group_name(admin.permission_group_id)))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 6
      }
    }, [_c('div', [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "primary",
        "ghost": ""
      },
      on: {
        "click": function($event) {
          return _vm.admin_btn(admin)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "danger",
        "ghost": ""
      },
      on: {
        "click": function($event) {
          return _vm.deletebtn(admin)
        }
      }
    }, [_vm._v("删除")])], 1)])], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.adminsum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "编辑管理员",
      "width": 600,
      "visible": _vm.admin_visible,
      "confirmLoading": _vm.adminLoading
    },
    on: {
      "ok": _vm.admin_Ok,
      "cancel": _vm.admin_Cancel
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("用户名")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.admin_info.username),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "username", $$v)
      },
      expression: "admin_info.username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": !_vm.admin_info.repassword_status,
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.admin_info.repassword),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "repassword", $$v)
      },
      expression: "admin_info.repassword"
    }
  }), _vm._v(" "), _c('a-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.admin_info.repassword_status),
      expression: "!admin_info.repassword_status"
    }],
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "click": function () {
        _vm.admin_info.repassword_status = true;
        _vm.admin_info.repassword = null
      }
    }
  }, [_vm._v("\n\t\t\t\t\t修改密码 ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("显示名")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入显示名"
    },
    model: {
      value: (_vm.admin_info.display_name),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "display_name", $$v)
      },
      expression: "admin_info.display_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.admin_info.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "phone_number", $$v)
      },
      expression: "admin_info.phone_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("手机验证")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "disabled": !_vm.admin_info.phone_number,
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.phone_verified),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "phone_verified", $$v)
      },
      expression: "admin_info.phone_verified"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入Email地址"
    },
    model: {
      value: (_vm.admin_info.email),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "email", $$v)
      },
      expression: "admin_info.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("Email验证")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "disabled": !_vm.admin_info.email,
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.email_verified),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "email_verified", $$v)
      },
      expression: "admin_info.email_verified"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("是否激活")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.is_active),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "is_active", $$v)
      },
      expression: "admin_info.is_active"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("是否雇员")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.is_staff),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "is_staff", $$v)
      },
      expression: "admin_info.is_staff"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("权限组设置")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function (value) {
        _vm.admin_info.permission_group_id = value
      }
    },
    model: {
      value: (_vm.admin_info.permission_group_id),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "permission_group_id", $$v)
      },
      expression: "admin_info.permission_group_id"
    }
  }, _vm._l((_vm.permission_group), function(item) {
    return _c('a-select-option', {
      key: item,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.permission_group_name))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("是否CMS管理员")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.is_cms),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "is_cms", $$v)
      },
      expression: "admin_info.is_cms"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("是否超级管理员")]), _vm._v(" "), _c('a-switch', {
    attrs: {
      "checkedChildren": "是",
      "unCheckedChildren": "否"
    },
    model: {
      value: (_vm.admin_info.is_super),
      callback: function($$v) {
        _vm.$set(_vm.admin_info, "is_super", $$v)
      },
      expression: "admin_info.is_super"
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dfca113","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/usermanagement/administratormanagement/index.vue
// module id = 2391
// module chunks = 1